export const LogoOnly = (props) => (
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0" y="0" width="40" height="40" rx="10" ry="10" fill="#10b981" />

    <g transform="translate(10, 10)">
      <path
        d="M3 0 L17 0 C18.657 0 20 1.343 20 3 L20 17 C20 18.328 18.828 19.5 17.5 19.5 C16.836 19.5 16.172 19.227 15.707 18.762 L10 13.055 L4.293 18.762 C3.828 19.227 3.164 19.5 2.5 19.5 C1.172 19.5 0 18.328 0 17 L0 3 C0 1.343 1.343 0 3 0 Z"
        fill="#ffffff"
      />

      <rect x="4" y="4" width="8" height="1.2" rx="0.6" fill="#9a9a9a" />
      <rect x="4" y="7" width="10" height="1.2" rx="0.6" fill="#9a9a9a" />
      <rect x="4" y="10" width="7" height="1.2" rx="0.6" fill="#9a9a9a" />
    </g>

    <circle cx="30" cy="30" r="2" fill="#9a9a9a" opacity="0.3" />
    <rect
      x="33"
      y="33"
      width="3"
      height="3"
      rx="0.5"
      fill="#9a9a9a"
      opacity="0.2"
    />
  </svg>
);
